/**
 * Footer Component
 * Simple footer with copyright and version info
 */

import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import branding from '../../config/branding';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 3,
        mt: 6,
        backgroundColor: 'background.paper',
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Typography variant="body2" color="text.secondary" align="center">
        © {currentYear}{' '}
        <Link color="inherit" href="/" underline="hover">
          {branding.appCopyright}
        </Link>
        {' · '}
        {branding.appDescription}
        {' · '}
        {import.meta.env.VITE_APP_VERSION || 'dev'}
      </Typography>
    </Box>
  );
};

export default Footer;
